/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import Analytics, { AnalyticsInstance, PageData } from 'analytics';
import googleAnalytics from '@analytics/google-analytics'
import segmentPlugin from '@analytics/segment';
import googleTagManager from '@analytics/google-tag-manager';
import config from '../../config';
import { AnalyticsEvents } from './AnalyticsEvents';
import { hotjar } from 'react-hotjar';
import { RootInitiativeData } from '../../types/initiative';

const { app, enabled, version, segment, googleAnalytics: ga, hotjar: hj, googleTagManager: gtm } = config.analytics;


type Callback = (...params: any[]) => any;
type Options = any;

class AnalyticsService {

  constructor(private analytics: AnalyticsInstance) {
    if (hj.id && hj.snippetVersion) {
      hotjar.initialize(Number(hj.id), Number(hj.snippetVersion), false);
    }
  }

  public async track(event: AnalyticsEvents, payload: object = {}, options?: Options, callback?: Callback) {
    return this.analytics.track(event, payload, options, callback)
  }

  public identify(userId: string, traits: object = {}, options?: Options, callback?: Callback) {
    return this.analytics.identify(userId, traits, options, callback)
  }

  // Only for segment
  public group(group: RootInitiativeData) {
    // @ts-expect-error segment is not defined in types
     
    window.analytics?.group(group._id, { name: group.name, type: group.type });
  }

  public page(data?: PageData, options?: Options, callback?: Callback) {
    return this.analytics.page(data, options, callback)
  }

  public user(key?: string): any {
    return this.analytics.user(key)
  }
}

let instance: AnalyticsService;
export const getAnalytics = () => {
  if (instance) {
    return instance;
  }

  /* Initialize analytics & load plugins */
  const plugins = enabled ? [
    googleAnalytics({ measurementIds: [ga.measurementId] }),
    segmentPlugin({
      writeKey: segment.writeKey,
      disableAnonymousTraffic: segment.disableAnonymousTraffic,
    }),
    googleTagManager({ containerId: gtm.containerId }),
  ] : [];

  const analytics = Analytics({
    app,
    version,
    plugins,
  })
  return instance = new AnalyticsService(analytics);
}
